import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface OpportunityApplicationInterviewState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpportunityApplicationInterview: [] | null | any;
}

const initialState: OpportunityApplicationInterviewState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpportunityApplicationInterview: null,
};

export const opportunityApplicationInterviewSlice = createSlice({
  name: 'OpportunityApplicationInterview',
  initialState,
  reducers: {
    setAllOpportunityApplicationInterview: (state, action) => {
      state.allOpportunityApplicationInterview = action.payload.data;
    },
    setOpportunityApplicationInterview: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpportunityApplicationInterviewBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: () => initialState,
  },
});

export const {
  setAllOpportunityApplicationInterview,
  setOpportunityApplicationInterview,
  setAllOpportunityApplicationInterviewBySearch,
  reset,
} = opportunityApplicationInterviewSlice.actions;

// Selectors
export const allOpportunityApplicationInterviewDetails = (state: RootState) =>
  state.opportunityApplicationInterview.allOpportunityApplicationInterview;

export const getOpportunityApplicationInterviewDetails = (state: RootState) =>
  state.opportunityApplicationInterview.data;

export const getOpportunityApplicationInterviewTotalRecords = (state: RootState) =>
  state.opportunityApplicationInterview.totalRecords;

export const getAllOpportunityApplicationInterviewBySearch = (state: RootState) =>
  state.opportunityApplicationInterview.data;

export default opportunityApplicationInterviewSlice.reducer;
